<template>
  <v-combobox
    v-model="select"
    :items="items"
    :label="label"
    item-value="value"
    multiple
    solo
    hide-details
    chips
    deletable-chips
    :return-object="false"
  ></v-combobox>
</template>

<script>
import { loadFacilities } from '@/core/archive'
import * as Security from '@/core/security'

export default {
  props: ['label', 'value'],
  data () {
    return {
      select: [],
      useFacilityDescription: false,
      items: []
    }
  },
  async mounted () {
    var noValue = Security.user.corporationDetails.find(d => d.Name === 'Sys_UseFacilityDescription')?.Data1 === undefined ?? false
    if (noValue) {
      this.useFacilityDescription = false
    } else {
      this.useFacilityDescription = Security.user.corporationDetails.find(d => d.Name === 'Sys_UseFacilityDescription')?.Data1 === 'true' ?? false
    }
    const facilities = await loadFacilities(0)
    if (!this.useFacilityDescription) {
      this.items = facilities.data.map(f => {
        return {
          text: f.No,
          value: f.No
        }
      })
    } else {
      this.items = facilities.data.map(f => {
        return {
          text: f.Description,
          value: f.Description
        }
      })
    }
  },
  watch: {
    select: {
      handler (val) {
        if (this.items.length) this.$emit('input', val)
      }
    },
    value: {
      handler (val) {
        this.select = val
      },
      immediate: true
    }
  }
}
</script>
